import { useCallback, useRef } from 'react';

export const useHasTriggered = () => {
  const ref = useRef(false);

  const hasTriggered = useCallback(() => {
    return ref.current;
  }, []);

  const markAsTriggered = useCallback(() => {
    ref.current = true;
  }, []);

  const reset = useCallback(() => {
    ref.current = false;
  }, []);

  const triggerOnce = useCallback((fn: () => void) => {
    if (!ref.current) {
      ref.current = true;
      fn();
    }
  }, []);

  return {
    hasTriggered,
    markAsTriggered,
    reset,
    triggerOnce,
  };
};
